import kioskSessionService from 'services/kiosk-session-service';
import store from 'store';
import { resumeKioskAction } from 'store/actions/kiosk-session-actions';

/**
 * On launch, if a kiosk token is persisted, re-derive the locked shell from it: lock immediately
 * (RESUMING) and re-validate against GET /KioskSession/Current. Runs after loadAuth so the kiosk
 * gate can take precedence over the normal auth router.
 */
const loadKiosk = async (): Promise<void> => {
  if (!kioskSessionService.getToken()) {
    return;
  }
  await store.dispatch(resumeKioskAction());
};

export default loadKiosk;
